<template>

</template>

<script>
  export default {
    name: "ConfigDepartmentEdit"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigDepartmentEdit.vue